import { render } from "./TDBG_SRSQ.vue?vue&type=template&id=68e8d0c2&scoped=true"
import script from "./TDBG_SRSQ.vue?vue&type=script&lang=js"
export * from "./TDBG_SRSQ.vue?vue&type=script&lang=js"

import "./TDBG_SRSQ.vue?vue&type=style&index=0&id=68e8d0c2&lang=css"
import "./TDBG_SRSQ.vue?vue&type=style&index=1&id=68e8d0c2&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e8d0c2"]])

export default __exports__